import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    treeLineItem: {
        color: theme.palette.text.primary
    },
    treeLineContextItem: {
        color: theme.palette.primary.main,
        fontWeight: "bold",
    },
    critical: {
        color: theme.palette.error.dark,
    },
    warning: {
        color: theme.palette.warning.main
    },
    low: {
        color: theme.palette.warning.main
    },
    fire: {
        color: theme.palette.secondary.light
    },
    info: {
        color: theme.palette.primary.dark
    },
    contextLabel: {
        fontWeight: 'bold'
    }
}));